import script from "./ListViewSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListViewSection.vue?vue&type=script&setup=true&lang=ts"

import "./ListViewSection.vue?vue&type=style&index=0&id=187953a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-187953a0"]])

export default __exports__